import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/home/customer.jpg'


const _hoisted_1 = { class: "counselling" }
const _hoisted_2 = { class: "counselling-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "form-box"
}
const _hoisted_6 = { class: "form-wrap" }

import { ref, watch, onMounted, onUnmounted, reactive } from 'vue'
import { asynchronousRetrieval } from '@/utils'
import { addConsult } from '@/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'CounsellingView',
  setup(__props) {

const loadUrl: any = ref({})
const showCode = ref(false)
const checkEmpty: any = ref({})
const contactInfo: any = reactive({
  companyName: '',
  name: '',
  phone: '',
  industry: null
})
const showError = ref(false)
const industryList = [
  {
    name: '文娱',
    value: 1,
  },
  {
    name: '工业',
    value: 2,
  },
  {
    name: '教育',
    value: 3,
  },
  {
    name: '其他',
    value: 4,
  }
]

const submitEvent = () => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  Object.keys(contactInfo).forEach((k) => {
    checkEmpty.value[k] = !contactInfo[k]
  })
  if (!reg.test(contactInfo.phone.replace(/\s+/g, "")) || !contactInfo.phone) {
    showError.value = true;
    return
  } else if (!contactInfo.companyName || !contactInfo.name || !contactInfo.industry) {
    return
  }
  addConsult({ ...contactInfo }).then((res: any) => {
    contactInfo.companyName = ''
    contactInfo.name = ''
    contactInfo.phone = ''
    contactInfo.industry = null
    showError.value = false;
    checkEmpty.value = {}
    showCode.value = true;
  })
}


onMounted(async () => {
  const banner_bg: any = await asynchronousRetrieval('webimg/images/about_us/banner-bg.png');
  loadUrl.value = { banner_bg }
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value.banner_bg
      }, null, 8, _hoisted_3),
      _cache[4] || (_cache[4] = _createElementVNode("div", null, "合作咨询", -1))
    ]),
    (showCode.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[5] || (_cache[5] = [
          _createStaticVNode("<div class=\"contact-us-box\" data-v-c35a7580><div class=\"title\" data-v-c35a7580>联系我们的团队</div><div data-v-c35a7580>你可以通过以下几种方式我们，我们将为您提供专业的解答</div></div><div class=\"code-box\" data-v-c35a7580><div data-v-c35a7580><div data-v-c35a7580><div data-v-c35a7580>扫码添加 客服微信</div><div style=\"position:relative;left:-10rem;\" data-v-c35a7580><img src=\"" + _imports_0 + "\" data-v-c35a7580></div></div><div data-v-c35a7580><div data-v-c35a7580>购买咨询</div><div data-v-c35a7580><div data-v-c35a7580>400-900-6269</div><div class=\"code-box-time\" data-v-c35a7580>工作日：9:30-18:30（北京时间）</div></div></div><div data-v-c35a7580><div data-v-c35a7580>联系邮箱</div><div data-v-c35a7580><div data-v-c35a7580>yang.he@njyjxr.com</div><div class=\"code-box-time\" data-v-c35a7580>48小时之内回复</div></div></div></div></div>", 2)
        ])))
      : _createCommentVNode("", true),
    (!showCode.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "成功提交信息，可添加客服微信提供一对一支持", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              class: _normalizeClass(["form-input", checkEmpty.value.companyName ? 'error-cn' : '']),
              modelValue: contactInfo.companyName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contactInfo.companyName) = $event)),
              placeholder: "公司名称"
            }, null, 8, ["class", "modelValue"]),
            _createVNode(_component_el_input, {
              class: _normalizeClass(["form-input", checkEmpty.value.name ? 'error-n' : '']),
              modelValue: contactInfo.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactInfo.name) = $event)),
              placeholder: "姓名"
            }, null, 8, ["class", "modelValue"]),
            _createVNode(_component_el_input, {
              class: _normalizeClass(["form-input", showError.value || checkEmpty.value.phone ? 'error-text' : '']),
              modelValue: contactInfo.phone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactInfo.phone) = $event)),
              placeholder: "电话"
            }, null, 8, ["class", "modelValue"]),
            _createVNode(_component_el_select, {
              placeholder: "所属行业",
              class: _normalizeClass([checkEmpty.value.industry ? 'error-i' : '', "select-default"]),
              modelValue: contactInfo.industry,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactInfo.industry) = $event)),
              "popper-class": "select-option"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(industryList, (item, index) => {
                  return _createVNode(_component_el_option, {
                    key: index,
                    label: item.name,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["class", "modelValue"])
          ]),
          _createElementVNode("div", {
            class: "submit-btn",
            onClick: submitEvent
          }, "提交信息")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})